export class BadRequestError extends Error {
  constructor() {
    super('Problem on the request body');
    this.name = 'BadRequestError';
  }
}
